import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Anuncia el cambio de ruta a lectores de pantalla leyendo el `<title>` del `document`.
 * Crítico para WCAG 2.1 — sin esto, los SPAs no notifican al usuario que ha cambiado de página.
 */
export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [message, setMessage] = useState("");
  const isInitial = useRef(true);

  useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
      return;
    }
    // Espera al siguiente frame para que <Helmet> haya actualizado el title.
    const id = window.setTimeout(() => {
      setMessage(document.title);
    }, 80);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  );
}
